import "./Filters.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMultiply } from "@fortawesome/pro-regular-svg-icons";
import { useTranslation } from "react-i18next";
import FilterDropdown from "./FilterDropdown";
import { ReactNode } from "react";

type FilterOptions = {
    [key: string]: { option: string; checked: boolean; label?: ReactNode }[];
};

interface IProps {
    clearAll: (key: string) => void;
    filterOptions: FilterOptions;
    onChange: (checked: boolean, filterOption: string, filterType: string) => void;
}

const Filters = (props: IProps) => {
    const { t } = useTranslation();

    const filteredOptions = {};

    Object.keys(props.filterOptions).forEach((key) => {
        if (props.filterOptions[key].length > 0) {
            filteredOptions[key] = props.filterOptions[key];
        }
    });

    return (
        <div className="filterDropdown">
            <div className="filters">
                {Object.keys(filteredOptions).map((key) => (
                    <FilterDropdown
                        key={key}
                        options={filteredOptions[key]}
                        name={key}
                        onChange={(checkBool, name) => props.onChange(checkBool, name, key)}
                        clearAll={() => props.clearAll(key)}
                    />
                ))}
            </div>
            <div className={`displaySelected`} onClick={() => props.clearAll("all")}>
                <div className="displaySelectedIconDiv">
                    <FontAwesomeIcon icon={faMultiply} className="displaySelectedIcon" />
                </div>
                <div className="selectedText">{`${t("CommonUI.shared.ClearFilters")}`}</div>
            </div>
        </div>
    );
};

export default Filters;
